




































import NotificationsButton from '@/components/notifications-button/notifications-button.vue';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {BreadCrumb, BreadCrumbItem, BreadCrumbs, LinkedBreadCrumb} from '@/components/action-bar/types';

@Component({
  components: {NotificationsButton}
})
export default class ActionBar extends Vue {

  @Prop({required: false})
  public breadCrumbs: BreadCrumbs;

  public goHome() {
    //window.history.back();
    this.goTo('home');
  }

  public handleClick(obj: BreadCrumbItem) {
    if ((obj as LinkedBreadCrumb).onClick) {
      (obj as LinkedBreadCrumb).onClick();
      return;
    }

    this.goTo((obj as BreadCrumb).link || '');
  }

  private goTo(route: string): void {
    this.$router.push({
      name: route
    });
  }
}
